import React from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";

import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";

import { cancelConfirmation, confirmPendingAction } from '../../store/actions/ConfirmDialog';

import StyledButton from "../styled/Button";

const ConfirmDialog = () => {
    const dispatch = useDispatch();
    const show = useSelector((state) => state.confirm.toggleConfirm);
    const message = useSelector((state) => state.confirm.message);

    const {t} = useTranslation();

    function onCancelConfirmation() {
        dispatch(cancelConfirmation());
    }

    function onConfirmPendingAction() {
        dispatch(confirmPendingAction());
    }

    return show && (
        <Dialog open={show}>
            <DialogTitle sx={{ padding: 1 }}>
                <Grid container alignItems='center'>
                    <Grid item marginRight='10px'>
                        <Warning color='primary' />
                    </Grid>
                    <Grid item>
                        <Typography>
                            {t('Warning!')}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent sx={{ padding: 1, textAlign: 'center' }}>
                {message}
            </DialogContent>
            <DialogActions sx={{ padding: 1 }}>
                <StyledButton
                    variant="contained"
                    onClick={onCancelConfirmation}
                >
                    {t('Cancel')}
                </StyledButton>
                <StyledButton
                    variant="contained"
                    onClick={onConfirmPendingAction}
                >
                    {t('Confirm')}
                </StyledButton>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
